import React from 'react';
import Forums from './Forums';

export default function ForumsPage() {
  console.log('ForumsPage rendering');
  
  return (
    <div className="forums-page-wrapper">
      <Forums />
    </div>
  );
} 